// extracted by mini-css-extract-plugin
export default {"container":"Load_container__HULOC"};